import * as React from 'react';
import classnames from 'classnames';
import { ProductImage } from '@grandvisionhq/fun-products';
import { LimeWrapper } from '@grandvisionhq/lib-lime';
import { useSelector } from '@grandvisionhq/state';
import { useTransitionColor } from '../../hooks/use-transition-color.js';
import { getSelectedFrame, getSelectedAddOn, getFrameImage } from '../../../../state/configurator/selectors.js';

const FrameImage = ({ className  })=>{
    var ref;
    const transitionColor = useTransitionColor();
    const frame = useSelector(getSelectedFrame);
    const selectedAddOn = useSelector(getSelectedAddOn);
    const frameImage = useSelector((s)=>getFrameImage(s, {
            width: 592
        })
    );
    const altText = `${frame === null || frame === void 0 ? void 0 : frame.brand} ${frame === null || frame === void 0 ? void 0 : frame.code}`;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('frame-image', className)
    }, frame && frameImage ? /*#__PURE__*/ React.createElement(ProductImage, {
        className: "frame-image__product",
        imageUrl: frameImage.url,
        altText: altText
    }, transitionColor && /*#__PURE__*/ React.createElement(LimeWrapper, {
        frameUPC: frame.sku,
        frameSrc: frameImage.url,
        lensColor: transitionColor,
        transitionType: selectedAddOn === null || selectedAddOn === void 0 ? void 0 : (ref = selectedAddOn.transitionType) === null || ref === void 0 ? void 0 : ref.toLowerCase()
    })) : null);
};

export { FrameImage };
//# sourceMappingURL=FrameImage.js.map
